import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const a = "translate";
class i extends s {
  /**
   * Translate a review and its first reply if it was made by AI suggestion.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/translate/review`
   *
   * @param {TranslateReviewParams} queryParams - The review id to translate and the target language
   * @returns {Promise<{review: string; reply: string | null}>} A promise resolving to the response data.
   */
  translateReview = async (e) => {
    const { data: t } = await this.get(`${a}/review`, e);
    return t;
  };
  /**
   * Translate a review reply suggestion.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/translate/reply_suggestion`
   *
   * @param {TranslateReviewReplySuggestionParams} queryParams - The review id + suggestion index to translate and the target language
   * @returns {Promise<SuccessResponse>} A promise resolving to the response data.
   */
  translateReviewReplySuggestion = async (e) => {
    const { data: t } = await this.get(
      `${a}/review_reply_suggestion`,
      e
    );
    return t;
  };
}
export {
  i as Translation
};
